import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

const SUPER_ADMIN_EMAIL = "hello@buukd.co";

export function usePlatformAdmin() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!user?.id) {
        setIsSuperAdmin(false);
        setRole(null);
        setLoading(false);
        return;
      }
      
      // Check email-based super admin first (matches database function logic)
      const userEmail = user?.email?.toLowerCase();
      if (userEmail === SUPER_ADMIN_EMAIL.toLowerCase()) {
        if (cancelled) return;
        setIsSuperAdmin(true);
        setRole("superadmin");
        setLoading(false);
        return;
      }
      
      // Check platform_admins table
      setLoading(true);
      const { data, error } = await (supabase as any)
        .from("platform_admins")
        .select("role")
        .eq("user_id", user.id)
        .maybeSingle();
      if (cancelled) return;
      if (error || !data) {
        setIsSuperAdmin(false);
        setRole(null);
      } else {
        setRole(String(data.role || ""));
        setIsSuperAdmin(String(data.role) === "superadmin");
      }
      setLoading(false);
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [user?.id, user?.email]);

  return { loading, isSuperAdmin, role };
}


